import { API } from "../api";

export const getUserProfileAPI = () => {
  return API.get<any>("/users/user-profile", {
    headers: {
      "clean-request": "no-clean",
    },
  });
};
